import { http } from '../helpers/axiosHelper';

export default class JourneyLanguageService {
   async postJourneyLanguage(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-language', body).then((response) => {
         return response.data;
      });
   }
}
